<template>
  <BaseTable
    :rows="courses"
    resource-name="Courses"
    @select="goToCourse"
  >
    <template #header>
      <th class="th">Code</th>
      <th class="th">Course Title</th>
      <th class="th">Credits</th>
      <th class="th">Requirement Designation</th>
      <th class="th">Course Attributes</th>
      <th class="th">Components</th>
      <th class="th">Academic Career</th>
    </template>
    <template #default="{ row: course }">
      <td>
        <NuxtLink 
          :to="getCourseUrl(course)"
          :aria-label="`Link to ${course.code || (course.subjectCode + course.courseNumber) || ''} course`"
        >
          {{ course.code || (course.subjectCode + course.courseNumber) || '-' }}
        </NuxtLink>
      </td>
      <td>
        {{ course.longName || '-'  }}
      </td>
      <td>
        {{ generateCreditValue(course) }}
      </td>
      <td style="word-break: break-word;">
        {{ getCustomField(course, 'catalogRequirementDesignation') || '-'  }}
      </td>
      <td>
        {{ (getCustomField(course, 'catalogAttributes') || []).filter(Boolean).join(', ') || '-'  }}
      </td>
      <td>
        {{ generateComponentsValue(course) }}
      </td>
      <td>
        {{ course.career || '-'  }}
      </td>
    </template>
  </BaseTable>
</template>

<script>
import useCourses from '@/composables/useCourses'

export default {
  props: {
    courses: {
      type: Array,
      required: true,
    },
  },
  setup(props, { root }) {
    const { goToCourse, getCourseUrl } = useCourses(root)
    return {
      goToCourse,
      getCourseUrl,
    }
  },
  methods: {
    generateCreditValue({ credits = {} }) {
      if (!credits.creditHours) return '-'
      const creditHours = credits.creditHours
      if (!creditHours.min && !creditHours.max) return '-'
      if (creditHours.min && creditHours.min === creditHours.max)
        return creditHours.min
      else return `${creditHours.min || 0} - ${creditHours.max || 0}`
    },
    generateComponentsValue({ components = [] }) {
      if (!components.length) return '-'
      return components
        .map(
          (el) =>
            `${el.contactHours || 0} ${el.name || 'Untitled Component'} Hours`
        )
        .filter(Boolean)
        .join(', ')
    },
    getCustomField(obj, key) {
      return obj.customFields ? obj.customFields[key] : null
    },
  },
}
</script>
